(function () {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

	}

	document.addEventListener('shopify:section:load', footer);
	footer();


    const menu = document.querySelector('.header-mobile__menu');
    const logo = document.querySelector('.header__heading-logo:first-child:nth-last-child(2) ~ .header__heading-logo');
  
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'class') {
          if (menu.classList.contains('active')) {
            logo.style.display = 'block';
            logo.style.zIndex = '10';
          } else {
            logo.style.display = '';
            logo.style.zIndex = '';
          }
        }
      });
    });
  
    observer.observe(menu, { attributes: true });


})();